// Hungarian
export const hu = {
    weeklyRewards: 'Heti jutalmak',
    days: 'nap',
    hours: 'óra',
    minutes: 'perc',
    seconds: 'mp',
    authenticating: 'Hitelesítés',
    verifyWallet: 'Kérjük, várjon, amíg ellenőrizzük a tárcáját',
    authRequired: 'Hitelesítés szükséges',
    authFailed: 'A hitelesítés sikertelen. Kérjük, próbálja újra.',
    points: 'Pont',
    rank: 'Helyezés',
    of: '/',
    players: 'játékos',
    weeklyTopPlayers: 'A hét legjobb játékosai',
    thisWeekLeaderboard: 'Heti ranglista',
    rankingsReset: 'A rangsor minden vasárnap éjfélkor (UTC) nullázódik',
    yourPoints: 'Az Ön pontjai',
    dailyRewardAvailable: 'Napi jutalom elérhető!',
    nextClaimAvailable: 'Következő igénylés elérhető:',
    claimDailyReward: 'Napi jutalom igénylése',
    claiming: 'Igénylés...',
    multiplier: 'Szorzó',
    bonusPointsMultiplier: 'Bónuszpont szorzó',
    outOf: '/',
    loading: 'Betöltés...',
    errorLoading: 'Hiba a betöltés során',
    noEntries: 'Nincsenek bejegyzések',
    leaderboard: 'Ranglista',
    tasks: 'Feladatok',
    rules: 'Szabályok',
    profile: 'Profil',
    comingSoon: 'Hamarosan...',
    completedTasks: 'Befejezett feladatok',
    dailyRewardsClaimed: 'Igényelt napi jutalmak',
    times: 'alkalom',
    recentActivity: 'Legutóbbi tevékenység',
    noRewardsClaimed: 'Még nem igényelt jutalmakat',
    dailyReward: 'Napi jutalom',
    howItWorks: 'Hogyan működik',
    welcomeMessage:
        'Üdvözöljük a Coinomi Rewards-ban! Szerezzen pontokat különböző feladatok teljesítésével és emelkedjen a ranglistán.',
    dailyRewardsTitle: 'Napi jutalmak',
    dailyRewardsRules: [
        'Igényelje napi jutalmát 24 óránként',
        'Minden igénylés 100 pontot ér',
        'A pontok szorzódnak az Ön szorzójával',
    ],
    multiplierBonusesTitle: 'Szorzó bónuszok',
    multiplierBonusesRules: [
        'Kezdjen 1x szorzóval',
        'Csatlakoztassa Telegramot +10% bónuszért',
        'Ellenőrizze e-mailjét +10% bónuszért',
        'A bónuszok halmozódnak a maximális jutalmakért',
    ],
    leaderboardTitle: 'Ranglista',
    leaderboardRules: [
        'Versenyezzen más játékosokkal',
        'A ranglista valós időben frissül',
        'A legjobb játékosok speciális jutalmakat kapnak',
    ],
    boostEarningsTitle: 'Növelje keresetét',
    boostEarningsRules: [
        'Teljesítsen kihívásokat bónuszokért',
        'Csatlakozzon Telegram közösségünkhöz',
        'Maradjon aktív a maximális jutalmakért',
    ],
    challenges: 'Kihívások',
    telegramChallenge: 'Telegram kihívás',
    emailChallenge: 'E-mail kihívás',
    connectTelegram: 'Telegram csatlakoztatása',
    shareEmail: 'E-mail megosztása',
    telegramSuccess: '🎉 Gratulálunk! Most már állandó 10% bónuszt kap minden jutalomra!',
    telegramPrompt:
        'Csatlakoztassa Telegram fiókját, hogy állandó 10% bónuszt kapjon minden jutalomra!',
    emailSuccess: '🎉 Gratulálunk! Most már állandó 10% bónuszt kap minden jutalomra!',
    emailPrompt: 'Ossza meg e-mailjét, hogy állandó 10% bónuszt kapjon minden jutalomra!',
    connectEmail: 'E-mail csatlakoztatása',
    cancel: 'Mégse',
    emailPrivacy: 'E-mailjét csak fontos frissítésekhez és jutalom értesítésekhez használjuk.',
    connectYourEmail: 'Csatlakoztassa e-mailjét',
    emailBonus: '🎉 Kapjon állandó 10% bónuszt minden jutalomra e-mailje csatlakoztatásával!',
    enterValidEmail: 'Kérjük, adjon meg egy érvényes e-mail címet',
    emailAddress: 'E-mail cím',
    errorSavingEmail: 'Hiba történt az e-mail mentése során. Kérjük, próbálja újra.',
    claimButton: 'Igénylés',
    earnedReward: 'Megszerzett jutalom',
    rewardValue: '{{amount}} Pont',
    claimingReward: 'Igénylés...',
    claimSuccess: 'Sikeresen igényelt {{amount}} pontot!',
    claimError: 'Az igénylés sikertelen. Kérjük, próbálja újra.',
    privacyDisclaimer:
        'A Coinomi nem gyűjt személyes adatokat; egy harmadik fél rendszere biztonságosan kezeli a pontokat és a közösségi kapcsolatokat.',
    streakBonus: 'Sorozat bónusz',
    streakDays: '{{days}}/5 Nap',
    streakBonusValue: '+{{percent}}%',
    streakMaxBonus: '+10% Extra',
    streakDescription: 'Igényeljen 5 egymást követő napon a maximális bónuszért',
    streakToday: 'Ma',
    streakMissed: 'Kihagyott',
    streakComplete: 'Teljesítve',
    streakActive: 'Aktív sorozat',
    streakLost: 'Elvesztett sorozat',
    streakNext: 'Következő',
    home: 'Kezdőlap',
    currentStreak: 'Jelenlegi sorozat',
    totalClaims: 'Összes igénylés',
    userStats: 'Az Ön statisztikái',
    referrals: 'Ajánlások',
    referralProgram: 'Ajánlási program',
    howReferralWorks: 'Hogyan működnek az ajánlások:',
    referralSteps: [
        'Ossza meg ajánlási linkjét barátaival',
        'Amikor az Ön linkjén keresztül csatlakoznak, az Ön ajánlottjaivá válnak',
        'Szerezzen bónuszpontokat minden aktív ajánlásért',
        'Kövesse nyomon ajánlásait és keresetét itt',
    ],
    referralRewards: 'Ajánlási pontok kiosztása:',
    referralBonuses: ['100 pont ajánlásonként', '10% minden pontból, amit az ajánlottja szerez'],
    yourReferralLink: 'Az Ön ajánlási linkje',
    copyToClipboard: 'Másolás vágólapra',
    linkCopied: 'Link másolva a vágólapra!',
    totalReferrals: 'Összes ajánlás',
    yourReferralCode: 'Az Ön ajánlási kódja',
    referralCodeCopied: 'Ajánlási kód másolva!',
    editReferralCode: 'Ajánlási kód szerkesztése',
    editReferralCodeInstructions:
        'Válasszon új ajánlási kódot. Legalább 5 karakterből kell állnia és tartalmazhat betűket és számokat.',
    newReferralCode: 'Új ajánlási kód',
    referralCodeRequirements: 'Minimum 5 karakter, csak betűk és számok',
    updating: 'Frissítés...',
    update: 'Frissítés',
    referralCodeTaken: 'Ez az ajánlási kód már foglalt',
    haveReferralCode: 'Van ajánlási kódja?',
    enterReferralCodePrompt:
        'Ha valaki ajánlotta Önt, írja be itt a kódjukat a fiókok összekapcsolásához.',
    enterReferralCode: 'Ajánlási kód megadása',
    enterReferralCodeInstructions: 'Írja be az Önnel megosztott ajánlási kódot.',
    referralCode: 'Ajánlási kód',
    referralCodeFormat: 'Csak betűk és számok',
    submitting: 'Beküldés...',
    submit: 'Beküldés',
    enterCode: 'Kód megadása',
    pleaseAddtoken: 'Kérjük, adja hozzá a token paramétert az URL-hez',
    authenticationError: 'Hiba történt a hitelesítés során',
    noUserFound: 'Nem található felhasználó',
    userNotFoundMessage: 'A felhasználói adatok nem találhatók',
    backToHome: 'Vissza a kezdőlapra',
    retry: 'Újrapróbálás',
    baseMultiplier: 'Alap szorzó',
    telegramBonus: 'Telegram bónusz',
    referralChallenge: 'Ajánlási kihívás',
    referralChallengePrompt:
        'Hívjon meg barátokat és szerezzen bónuszpontokat! Kapjon 100 pontot minden ajánlásért plusz 10%-ot a kereseteikből.',
    startReferring: 'Ajánlás kezdése',
    referralSuccess: '🎉 Gratulálunk! Sikeresen ajánlott felhasználókat és bónuszpontokat szerez!',
    unranked: 'Rangsorolatlan',
    noPlayersYet: 'Legyen Ön az első, aki csatlakozik!',
    shareVia: 'Megosztás',
    shareOn: 'Megosztás {{network}}en',
    shareInviteText:
        '🚀 Ingyenes kriptovalutát keresek a @CoinomiWallet-tel!\n\nTöltse le a Coinomi-t a coinomi.com/downloads oldalról és adja meg a hivatkozási kódomat {{referralCode}} a bónusz megszerzéséhez, amikor csatlakozik a #Coinomi Rewards alkalmazáshoz.',
    yourStatsThisWeek: 'Statisztikáid ezen a héten',
    pointsMultiplier: 'Pontszorzó',
    yourRank: 'Helyezésed',
    rewards: 'Jutalmak',
    daily: 'Napi',
    weekly: 'Heti',
    claimRewards: 'Jutalmak igénylése',
    copy: 'Másolás',
    // Twitter Challenge
    twitterChallenge: 'Twitter kihívás',
    connectTwitter: 'Twitter csatlakozás',
    twitterSuccess: '🎉 Gratulálunk! Mostantól 10% állandó bónuszt kapsz minden jutalomra!',
    twitterPrompt:
        'Csatlakoztasd Twitter fiókodat, hogy 10% állandó bónuszt kapj minden jutalomra!',
    pleaseAddUserId: 'Kérjük, adjon hozzá userId paramétert az URL-hez',
    emailChallengePrompt: 'Ossza meg e-mailjét, hogy állandó 10% bónuszt kapjon minden jutalomra!',
    emailChallengeSuccess: '🎉 Csatlakoztatva! Mostantól 10% állandó bónuszt kap minden jutalomra!',
    followKoalaWalletChallenge:
        'Kövesse a @coinomiWallet fiókot Twitteren, hogy támogasson minket!',
    twitterAuthSuccessTitle: 'Twitter sikeresen csatlakoztatva!',
    twitterAuthSuccessMessage:
        'Sikeresen csatlakoztatta Twitter fiókját. Most már folytathatja az alkalmazás használatát.',
    continueToApp: 'Tovább az alkalmazáshoz',
    twitter_like: 'Kedvelte a tweetet',
    twitter_retweet: 'Retweetelte a tweetet',
    disconnect: 'Leválasztás',
    followCoinomiWallet: 'Kövesd a @coinomiWallet fiókot Twitteren, hogy támogass minket!',
    connectedBonus: '🎉 Csatlakoztatva! Mostantól állandó 10% bónuszt kapsz minden jutalomra!',
};
